import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { VolunteerProspect } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService, app: AppService) {
	console.log(domainData.data().accApplicationStatusesMap)
	const columns: GridColumn<VolunteerProspect, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 30 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 30 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 20 }),
		buildColumn(util, 'Id', row => row.volunteerId),
		buildColumn(util, 'FullName', row => row.person.fullName, { width: 40 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Lead Created Date', width: 30 }),
		buildColumn(util, 'Text', row => domainData.data().volunteerStatusesMap[row.volunteerStatusId]?.name, { header: 'Status', width: 30 }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.interviewDateUTC), { header: 'Interview Date', width: 30 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated Date', hidden: true }),
		buildColumn(util, 'YesNo', row => row.mentorInterest, { header: 'Mentor Interest', hidden: true }),
		buildColumn(util, 'YesNo', row => row.inClassInterest, { header: 'In-Class Interest', hidden: true }),
		buildColumn(util, 'YesNo', row => row.officeHoursInterest, { header: 'Office Hours Interest', hidden: true }),
		buildColumn(util, 'YesNo', row => row.willVolunteerInEnglish, { header: 'English', hidden: true }),
		buildColumn(util, 'YesNo', row => row.willVolunteerInSpanish, { header: 'Spanish', hidden: true }),
		buildColumn(util, 'Text', row => row.availableStart, { header: 'Start Date', hidden: true }),
		buildColumn(util, 'Percent', row => row.interviewScore, { header: 'Interview Score', width: 30, hidden: true }),
	];

	return columns;

}
